export default __webpack_public_path__ + "src/images/packages/clifftop-exclusive-safari/741873f98740e47bda5b9fa5fbfd6a52-4.jpeg";